import React from 'react';
import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material';

const ProgressPanel = ({
  variant = 'panel',
  size = 28,
  title,
  stage,
  progress,
  containerSx = {},
}) => {
  if (variant === 'inline') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, ...containerSx }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={size} />
          {title && (
            <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
              {title}
            </Typography>
          )}
        </Box>
        {stage && (
          <Typography variant="caption" color="text.secondary">
            {stage}{Number.isFinite(progress) ? ` (${Math.round(progress)}%)` : ''}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, ...containerSx }}>
      <CircularProgress size={size} />
      {title && (
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {title}
        </Typography>
      )}
      {stage && (
        <Typography variant="body2" color="text.secondary">
          {stage}{Number.isFinite(progress) ? ` (${Math.round(progress)}%)` : ''}
        </Typography>
      )}
      <Box sx={{ width: '100%', maxWidth: 360 }}>
        <LinearProgress variant="determinate" value={Math.min(100, Math.max(0, progress || 0))} />
      </Box>
    </Box>
  );
};

export default ProgressPanel;
